import type { PanelType } from "../components/reusable/PanelSelector";
import { getPanelLabel } from "../components/reusable/PanelSelector";
import type { SvgToolHandoffSlot } from "./svgToolHandoff";

export type SvgHandoffMenuOption = {
    /** Stable value for `<option>` */
    optionId: string;
    targetPanel: PanelType;
    slot: SvgToolHandoffSlot;
};

/** Destinations that accept an incoming SVG handoff (expand over time). */
export const SVG_HANDOFF_TARGET_OPTIONS: SvgHandoffMenuOption[] = [
    {
        optionId: "object-along-path--path",
        targetPanel: "object-along-path",
        slot: "path",
    },
    {
        optionId: "object-along-path--object",
        targetPanel: "object-along-path",
        slot: "object",
    },
    {
        optionId: "object-fill-pack--path",
        targetPanel: "object-fill-pack",
        slot: "path",
    },
    {
        optionId: "object-fill-pack--object",
        targetPanel: "object-fill-pack",
        slot: "object",
    },
    {
        optionId: "grid-editor--primary",
        targetPanel: "grid-editor",
        slot: "primary",
    },
    {
        optionId: "primitive-points--object",
        targetPanel: "primitive-points",
        slot: "object",
    },
    {
        optionId: "primitive-points--primary",
        targetPanel: "primitive-points",
        slot: "primary",
    },
    {
        optionId: "path-agents--path",
        targetPanel: "path-agents",
        slot: "path",
    },
    {
        optionId: "path-agents--primary",
        targetPanel: "path-agents",
        slot: "primary",
    },
    {
        optionId: "svg-to-raster--primary",
        targetPanel: "svg-to-raster",
        slot: "primary",
    },
    {
        optionId: "displacement-map--primary",
        targetPanel: "displacement-map",
        slot: "primary",
    },
    {
        optionId: "channel-split--primary",
        targetPanel: "channel-split",
        slot: "primary",
    },
    {
        optionId: "distortion-grid--primary",
        targetPanel: "distortion-grid",
        slot: "primary",
    },
    {
        optionId: "point-distortion--primary",
        targetPanel: "point-distortion",
        slot: "primary",
    },
    {
        optionId: "lattice-deform--primary",
        targetPanel: "lattice-deform",
        slot: "primary",
    },
    {
        optionId: "grid-cell-wrapper--primary",
        targetPanel: "grid-cell-wrapper",
        slot: "primary",
    },
    {
        optionId: "grid-cubes-3d--object",
        targetPanel: "grid-cubes-3d",
        slot: "object",
    },
    {
        optionId: "grid-cubes-3d--primary",
        targetPanel: "grid-cubes-3d",
        slot: "primary",
    },
];

const SLOT_SUFFIX: Record<SvgToolHandoffSlot, string> = {
    path: "as path SVG",
    object: "as object SVG",
    primary: "as source SVG",
};

export function handoffOptionLabel(opt: SvgHandoffMenuOption): string {
    return `${getPanelLabel(opt.targetPanel)} — ${SLOT_SUFFIX[opt.slot]}`;
}

export function handoffOptionsForSlots(
    allowedSlots: SvgToolHandoffSlot[],
    excludeTargetPanels?: PanelType[],
): SvgHandoffMenuOption[] {
    const skip = new Set(excludeTargetPanels ?? []);
    return SVG_HANDOFF_TARGET_OPTIONS.filter(
        (o) =>
            allowedSlots.includes(o.slot) && !skip.has(o.targetPanel),
    );
}
